import React from "react";
import Reveal from "./Reveal";
import TiltCard from "./TiltCard";
import { projects } from "../data/content";
import { FiMapPin } from "react-icons/fi";

export default function Projects() {
  return (
    <section id="projects" className="section">
      <div className="container">
        <Reveal>
          <div className="eyebrow">Featured Work</div>
          <h2 className="section-title">
            20+ products shipped. <span className="gradient-text">A few highlights.</span>
          </h2>
          <p className="section-sub">Across India, UAE, and international markets — for startups, SMEs, and founders.</p>
        </Reveal>

        <div
          className="projects-grid"
          style={{ marginTop: 56, display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 24 }}
        >
          {projects.map((p, i) => (
            <Reveal key={p.title} delay={(i % 2) * 0.1} style={i === projects.length - 1 ? { gridColumn: "1 / -1" } : undefined}>
              <TiltCard intensity={5} style={{ height: "100%" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                  <h3 style={{ fontSize: 22 }}>{p.title}</h3>
                  <span
                    className="tag"
                    style={{ display: "flex", alignItems: "center", gap: 5, flexShrink: 0 }}
                  >
                    <FiMapPin size={11} /> {p.region}
                  </span>
                </div>
                <p style={{ color: "var(--text-muted)", fontSize: 15, lineHeight: 1.7, marginBottom: 18 }}>
                  {p.description}
                </p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 16 }}>
                  {p.scope.map((s) => (
                    <span
                      key={s}
                      style={{
                        fontSize: 12,
                        color: "var(--accent-3)",
                        fontFamily: "var(--font-mono)",
                        border: "1px solid rgba(0,255,157,0.25)",
                        padding: "3px 10px",
                        borderRadius: 999,
                      }}
                    >
                      {s}
                    </span>
                  ))}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, borderTop: "1px solid var(--border)", paddingTop: 16 }}>
                  {p.stack.map((t) => (
                    <span key={t} className="tag">
                      {t}
                    </span>
                  ))}
                </div>
              </TiltCard>
            </Reveal>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 800px) {
          .projects-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
